export default __webpack_public_path__ + "static/media/img_declaration_promise2.ff747271.png";